import React from "react";
import styled from "@emotion/styled";
import { EBookDownloadForm } from './EBookDownloadForm';
import withTranslator from "../..//Translator/withTranslation";
import { renameProps } from "recompose";

const Container = styled.div`
    position: relative;
`;

const  Background = styled.div`
    position:absolute;
    height:75vh;
    background: linear-gradient( rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) ), url('/assets/img/front/ebook-download-bg.jpg') 0 -140px; 
    background-position:0px 0px; 
    background-repeat: no-repeat; 
    background-size:cover; 
    min-height:75vh;
    clip-path: ellipse(100% 100% at 50% 0); 
    -webkit-clip-path: ellipse(100% 100% at 50% 0); 
    margin-bottom:100px; 
    width:100%;
    top: -30%;
    z-index: -1;

    @media(max-width:420px) {
        height: 100vh;
        top:-45%;
        background: url('/assets/img/front/ebook-download-bg.jpg');
        clip-path: none;
        -webkit-clip-path: none;
    }
`;
const HeadLine = styled.div`
    font-size:3.7em;
    line-height: 1.7em;
    text-transform: uppercase;
    text-align:center;
    @media (max-width:1200px) {
        font-size:2.6em;
        line-height:2em;
        text-align:center;
    }
    @media (max-width:768px) {
        font-size:2em;
        line-height:1.5em;
        text-align:center;
    }
    @media (max-width:420px) {
        font-size:1.5em;
        line-height:1.5em;
        text-align:center;
    }
`;
const TagLine = styled.div`
    font-size: 1.5em;
    line-height: 1.5em;
    width: 100vw;
    text-align:center;
    @media (max-width:1200px) {    
        /* line-height:2em; */
        font-size: 1.2em;
        text-align:center;
    }
    @media (max-width:768px) {
        /* line-height:1.5em; */
        font-size: 1em;
        text-align:center;
    }
    @media (max-width:400px) {
        font-size:0.9em;
        line-height:1.5em;
        text-align:center;
    }
`;
const ElementRow = styled.div`
    min-height:500px;
    margin-bottom:100px; 
    @media (max-width:400px) {
        min-height:50vh;
        align-items:baseline;
        padding-top:1em!important;
    }
`;

const HeroContainer = styled.div`
    @media (max-width:400px) {
        min-height: 450px;
    }
`;
const EBookDownloadInnerComponent = (props) => {
    return (
        <HeroContainer className="">
            <Background />
            <Container className="container" >
                <ElementRow className="row items-fstart pt-lg-5 pt-md-3 pt-1  ">
                    <div className="col-12  white flex flex-column px-lg-5 px-md-3 px-lg-0 pb-3 justify-saround">
                        <HeadLine className="white font-300 font-w600 text-uppercase" dangerouslySetInnerHTML={{__html: props.t('ebook_title')}} />
                        <div className="flex">
                        <TagLine dangerouslySetInnerHTML={{__html: props.t('ebook_lloret_de_mar_tagline')}} />
                        </div>
                    </div>
                    <div className="offset-md-2 col-md-8 offset-lg-3 col-lg-6 flex flex-column">
                            <EBookDownloadForm {...props} />
                    </div>
                </ElementRow>
                
            </Container>
        </HeroContainer>
    );
}

export const EBookDownloadInner = withTranslator(EBookDownloadInnerComponent);